import {
  FormEnumFieldWidget,
  FormFieldWidget,
  ModelFieldType,
  SPI,
  ViewType,
  Widget
} from '@kunlun/dependencies';
import { TIssuingMethod, useProxyDelivery } from '../../../../hooks';
import { Ref, toRef } from 'vue';

@SPI.ClassFactory(
  FormFieldWidget.Token({
    viewType: ViewType.Form,
    ttype: ModelFieldType.Enum,
    model: [
      'deli.aries.seller.SellerDistributionCreateOrderParam',
      'deli.aries.seller.SellerDistributorAuditOrderParam',
      'deli.aries.seller.DeliAriesSellerPurchasingPlan',
      'deli.aries.seller.DeliAriesSellerSpecialApplyOrder'
    ],
    name: 'deliveryAreaTypeEnum',
    multi: false
  })
)
export class FormEnumSendAreaFieldWidget extends FormEnumFieldWidget {
  @Widget.Reactive()
  disabled_ = false;

  @Widget.Reactive()
  get disabled(): boolean {
    return this.disabled_;
  }

  watchProxyMethod(key: string, value: string) {
    if (value) {
      const { sendAreaDisabled, deliveryAreaTypeEnum } = useProxyDelivery(
        toRef(this.formData, key) as Ref<TIssuingMethod>
      );
      this.setValue(deliveryAreaTypeEnum.value);
      this.disabled_ = sendAreaDisabled.value;
    }
  }

  @Widget.Watch('formData.ariesIssuingMethodEnum', { immediate: true })
  protected watchAriesIssuingMethodEnum(value: string) {
    this.watchProxyMethod('ariesIssuingMethodEnum', value);
  }

  // 要货计划的字段：
  // 代发方式 issuingMethod
  @Widget.Watch('formData.issuingMethod', { immediate: true })
  protected watchIssuingMethod(value: string) {
    this.watchProxyMethod('issuingMethod', value);
  }

  // 要货计划的字段：
  // 代发方式 issuingMethod
  @Widget.Watch('formData.issuingMethodEnum', { immediate: true })
  protected watchIssuingMethodEnum(value: string) {
    this.watchProxyMethod('issuingMethodEnum', value);
  }
}
